export default __webpack_public_path__ + "static/media/face9.4cd8d692.svg";